import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../environments/environment';

@Injectable({ providedIn: 'root' })
export class LeaveService {
    constructor(private http: HttpClient) { }
    getAll(perPage:number, page:number) {
        return this.http.get<any>(`${environment.apiUrl}/employee/leave?perPage=${perPage}&page=${page}&order_way=desc`)
    }
    getByManage(perPage:number, page:number) {
        return this.http.get<any>(`${environment.apiUrl}/employee/leave/manage?perPage=${perPage}&page=${page}&order_way=desc`)
    }
    postRequest(data:any) {
        return this.http.post<any>(`${environment.apiUrl}/employee/leave`, data)
    }
    deleteRequest(id:string) {
        return this.http.delete<any>(`${environment.apiUrl}/employee/leave/${id}`) ;
    }
    acceptRequest(id:string){
        var data = {
            "is_approved": 1
        }
        return this.http.patch<any>(`${environment.apiUrl}/employee/leave/${id}`, data) ;
    }
    cancelRequest(id:string){
        var data = {
            "is_approved": 2
        }
        return this.http.patch<any>(`${environment.apiUrl}/employee/leave/${id}`, data) ;
    }
    approved(perPage:number, page:number) {
        return this.http.get<any>(`${environment.apiUrl}/employee/leave/manage?perPage=${perPage}&page=${page}&order_way=desc&is_approved=1`)
    }
    waiting(perPage:number, page:number) {
        return this.http.get<any>(`${environment.apiUrl}/employee/leave/manage?perPage=${perPage}&page=${page}&order_way=desc&is_approved=0`)
    }
}